<template>
  <Window :id="'newMaintenance'" :title="isEdit?getLanguageStr('word1994','编辑维保记录'):getLanguageStr('word1993','添加新维保记录')" ref="newEdit" @Close="myClose">
    <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
      <button class="bdSub boxR hover-bg-highLight" @click="Close">{{$t('cmd85',['取消'])}}</button>
      <button class="functionBtn" :class="{disable:(form.name==''||form.systemTypeId==null||form.personIds.length==0||form.objectNameList.length==0)}" @click="save" type="button">{{$t('cmd84',['保存'])}}</button>
    </div>
    <div fillHeight="window,-#newMaintenance .head" scroll>
      <div class="w70pct mc mt2x mb2x">
        <ul class="mt2x_E vaT_E">
          <li>
            <div class="cSub mb1x" :title="getLanguageStr('word693','名称')"><span class="cWarning">*</span>{{getLanguageStr('word693','名称')}}</div>
            <InputText class="w100pct" v-model="form.name" name="name" :maxlength="500"></InputText>
          </li>
          <li>
            <div class="cSub mb1x" :title="getLanguageStr('plant233','维保人')"><span class="cWarning">*</span>{{getLanguageStr('plant233','维保人')}}:</div>
            <related-person :maxNum='5' class="afterNew w80pct mt2x" @Update="updatePersonList" ref="AddPerson" title="" :initPersonData="initPersonData" v-if="editPersonShow"></related-person>
          </li>
          <li class="cb">
            <div class="w46pct fL">
              <div class="cSub mb1x" :title="getLanguageStr('word1999','维保系统')"><span class="cWarning">*</span>{{getLanguageStr('word1999','维保系统')}}:</div>
              <div class="cb">
                <Select :list="maintenanceSystemList" :size="'m'" :bindActive="form.systemType" v-model="form.systemType" :keyMap="{text:'name',value:'value'}" class="w30pct fL mr05x" :class="{disable:doNotEdit}"></Select>
                <InputText class="w65pct fL disable cSub" v-model="form.systemTypeName" name="systemTypeName" v-if="doNotEdit" :disabled="'disabled'"></InputText>
                <transition-group tag="div" name="fade" class="jia fL w65pct bdSub sizeM  tra-fast" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500" v-else>
                  <TagBox v-for="(tag,key) in targetList" :key="key" :val="tag.name" @Remove="removeTarget()"></TagBox>
                  <button class="cMain sizeS " :key="'pleaseSelect'" @click="openStation" type="button" v-if="targetList.length==0">+{{$t('word204',['电站'])}}</button>
                </transition-group>
              </div>
              <div class="station-wrap" v-if="stationFlag" v-clickoutside="handleClose" @mouseleave="showStatMousePos=false" @mouseenter="showStatMousePos=true">
                <SelectStationCommon :fromW="true" :powerTypeList="powerTypeList" @EmitStationIdListSingle='EmitStationIdList' :filterFlag="false" :fromInset="true" ref='SelectStationCommon'></SelectStationCommon>
              </div>
            </div>
            <div class="w46pct fL ml5x" v-show="form.systemTypeId">
              <div class="cSub mb1x" :title="getLanguageStr('word2001','维保对象')"><span class="cWarning">*</span>{{getLanguageStr('word2001','维保对象')}}:</div>
              <div class="cb fL_E">
                <div class="w30pct pr05x">
                  <Select :list="maintenanceObjectList" :size="'m'" :bindActive="form.objectType" v-model="form.objectType" :keyMap="{text:'name',value:'value'}" @Click="targetIndex=>changeObjectType(maintenanceObjectList[targetIndex].value)"></Select>
                </div>
                <AlarmStation v-if="form.objectType==1" @Update="UpdateObj" :type="2" :targetId="form.systemTypeId" class="w70pct" ref="AlarmStation" :filter="{}" :fromW="true"></AlarmStation>
                <InputText v-else v-model="form.objectNameList[0]" name="objectType" class="w70pct" :maxLength="500" @input="watchObject()"></InputText>
              </div>
            </div>
          </li>
          <li class="posR">
            <div class="cSub mb1x" :title="getLanguageStr('word2003','维保时间:')"><span class="cWarning">*</span>{{getLanguageStr('word2003','维保时间:')}}</div>
            <div style="position: relative;" class='time dpIB'>
              <vue-datepicker-local v-model="form.time" format="YYYY/MM/DD HH:mm:ss" class="sizeM w60pct"></vue-datepicker-local>
            </div>
          </li>
          <li>
            <div class="cSub mb1x" :title="getLanguageStr('word2004','维保内容:')"><span class="cWarning">*</span>{{getLanguageStr('word2004','维保内容:')}}:</div>
            <editor-bar v-model="form.content" @change="change" id="contentEditor" ref="editContent"></editor-bar>
          </li>
          <li>
            <div class="cSub mb1x" :title="getLanguageStr('word1216','备注:')">{{getLanguageStr('word1216','备注')}}:</div>
            <editor-bar v-model="form.remarks" @change="changeRemarks" ref="editRemarks"></editor-bar>
          </li>
        </ul>
        <div id="cover" class="cover"></div>
      </div>
    </div>
  </Window>
</template>
<script>
import * as lib from '@/util/lib.js'
import Window from '@/components/common/ui/WindowForNew.vue'
import Select from '@/components/common/ui/Select.vue'
import InputText from '@/components/common/ui/InputText.vue'
import RelatedPerson from '@/view/maintain/light/plant/part/RelatedPerson'
import SelectStationCommon from '@/components/common/SelectStationCommon'
import TagBox from '@/components/common/ui/TagBox.vue'
import clickoutside from '@/plugins/clickOutSide/index.js'
import AlarmStation from "@/view/maintain/alarm/part/AlarmStation.vue"
import EditorBar from './WangEditor'
import { insert, update, get } from '@/api/maintain/maintenance/list.js'
export default {
  name: 'newMaintenance',
  components: { RelatedPerson, Window, Select, InputText, SelectStationCommon, TagBox, AlarmStation, EditorBar },
  directives: { clickoutside },
  props: {
    systemType: {
      type: Number,
      default: 1
    },
    systemTypeId: {
      type: [Number, String],
      default: null
    },
    systemTypeName: {
      type: String,
      default: null
    },
    powerTypeList:{//指定电站能源类型
      type:Array,
      default:undefined
    }
  },
  data () {
    return {
      stage,
      instance: null,
      isEdit: false,
      stationFlag: false,
      targetList: [],
      editPersonShow: false,
      stationIdList: [],
      showStatMousePos: false,
      contentVerify: {
        fLength: 0,
        imgLength: 0
      },
      remarksVerify: {
        fLength: 0,
        imgLength: 0
      },
      maintenanceSystemList: (function () {
        let y = lib.getTypeText('', 'maintenanceSystem', true)
        return y
      }()),
      maintenanceObjectList: (function () {
        let y = lib.getTypeText('', 'maintenanceObject', true)
        return y
      }()),
      device: {
        selectedId: [],
        show: false, // 整体
        list: [],
        flag: false,
        sn: '',
        loading: true,
        DeviceList: [],
        deviceListShow: false,
        deviceSelect: '',
        selectAllStatus: 0
      },
      form: {
        id: null,
        name: '',
        content: '',
        objectNameList: [],//维保对象sn
        objectType: null,//维保对象类型
        personIds: [],//维保人Id
        personNames: [],
        remarks: '',
        systemType: 1,
        systemTypeId: null,//维保系统
        systemTypeName: '',
        time: new Date(),
        timezone:stage.time.timeZone
      },
      editor: null,
      editor1: null,
      initPersonData: [],
      doNotEdit: false,//电站不可编辑
      wangEdit: false
    }
  },
  computed: {},
  methods: {
    getTypeText: lib.getTypeText,
    getLanguageStr,
    transitionAction: lib.transitionAction,
    watchObject () {
      if (this.form.objectNameList[0] == "") {
        this.form.objectNameList = []
      }
    },
    changeObjectType (v) {
         this.form.objectNameList.splice(0)
         this.form.objectNameList.length=0
    },
    Close: function () {
      this.editPersonShow = false
      this.$refs.newEdit.hide()
      this.reset();
    },
    reset () {
      this.initPersonData = [];
      this.targetList = [];
      this.form = {
        name: '',
        content: '',
        objectNameList: [],//维保对象sn
        objectType: null,//维保对象类型
        personIds: [],//维保人Id
        personNames: [],
        remarks: '',
        systemType: 1,
        systemTypeId: null,
        systemTypeName: '',
        time: new Date(),
        timezone:stage.time.timeZone
      }
      // this.$refs.editContent.reset();
      // this.$refs.editRemarks.reset();//点击取消清空富文本
    },
    //获取详情
    get (id) {
      get(id).then(res => {
        this.form = Object.assign({}, this.form, res);
        for (let i = 0; i < this.form.personIds.length; i++) {
          this.initPersonData[i] = {
            'id': this.form.personIds[i],
            'name': this.form.personNames[i]
          }
        }
        this.targetList = [{ 'name': res.systemTypeName }]
        this.form.time = new Date(res.time * 1000)
        this.$refs.AddPerson.show();
        //将已选中的设备传入组件
        if (this.form.objectType == 1) {
          let deviceData = []
          if (this.form.deviceDetailList != null) {
            this.form.deviceDetailList.map((item, index) => {
              if (item.name != null) {
                item.name = item.name + item.serialNumber
              } else {
                item.name = this.getTypeText(item.type, 'deviceType') + item.serialNumber
              }
              item.isSelect = true
              //	deviceData[index]={id:item.id,name:str,isSelect:true}
            })
          }
          this.$nextTick(() => {
            this.$refs.AlarmStation.show(this.form.deviceDetailList)
          });
        }
        this.$nextTick(() => {
          this.$refs.newEdit.show({            end: () => {
              setTimeout(() => {
                this.$refs.editContent.initThis();
                this.$refs.editRemarks.initThis();
                this.$refs.editContent.editFuzhi(this.form.content);
                this.$refs.editRemarks.editFuzhi(this.form.remarks);
              }, 100);
            }          });
          this.wangEdit = true
          this.$nextTick(() => {
            // this.$forceUpdate();
          })
        });
        lib.setScroll($(this.$el).find('[fillHeight][scroll]'));
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    show (data, instance) {
      this.doNotEdit = false
      this.editPersonShow = true
      //请注意data若有值,即为通过点击编辑过来
      //	 $("#contentEditor").find(".editor-text").blur();
      if (data) {
        this.isEdit = true;
        this.get(data.id)
      } else {
        this.reset();
        this.isEdit = false
        this.$refs.newEdit.show({          end: () => {
            setTimeout(() => {
              this.$refs.editContent.initThis();
              this.$refs.editRemarks.initThis();
            }, 100);
          }        });

      }
      //来自电站
      if (this.systemTypeId != null) {
        this.doNotEdit = true
        this.form.systemTypeId = this.systemTypeId
        this.form.systemTypeName = this.systemTypeName
        this.form.objectType = 1
      }
    },
    myClose () {
      setTimeout(() => {
        if (this.instance) {
          this.instance.destroyUi()
        }
      }, 500)
    },
    handleClose (e) {
      if (!this.showStatMousePos) {
        this.stationFlag = false
      }
    },
    change (val, t, n) {
      this.contentVerify = Object.assign({}, this.contentVerify, {
        fLength: t,
        imgLength: n
      })
      this.form.content = val;
    },
    changeRemarks (v, t, n) {
      this.form.remarks = v;
      this.remarksVerify = Object.assign({}, this.remarksVerify, {
        fLength: t,
        imgLength: n
      })
    },
    clear () {
      this.device.selectedId = []
      this.device.DeviceList.forEach(el => {
        this.$set(el, 'isSelect', false)
      })
      this.selectedData()
    },
    onRemove (id, index) {
      this.device.DeviceList.forEach((el, index) => {
        if (el.id === id) {
          this.device.DeviceList[index].isSelect = false
        }
      })
      this.selectedData()
    },
    updatePersonList (idArr, obj, nameArr) {
      this.form.personIds = idArr
      this.form.personNames = nameArr
    },
    UpdateObj (station, device) {
      this.form.deviceDetailList = device
      this.form.objectNameList = []
      if (device.length > 0) {
        for (let i = 0; i < device.length; i++) {
          this.$set(this.form.objectNameList, i, device[i].id);
        };
      } else {
        this.form.objectNameList = []
      }
    },
    save () {
      if(this.form.timezone==null){
        this.form.timezone =stage.time.timeZone
      }
      let data = this.form;
      if (this.contentVerify.fLength == 0 && this.form.content.length == 0) {
        this.$notify(this.getLanguageStr('record7', '维保内容不能为空'))
        return false;
      } else if (this.contentVerify.fLength > 2500) {
        this.$notify(i18n.t('record3', [2500, '维保内容不能超过2500个字']))
        return false;
      } else if (this.remarksVerify.fLength > 2500) {
        this.$notify(i18n.t('record4', [2500, '备注不能超过2500个字']))
        return false;
      } else if (this.contentVerify.imgLength > 25) {
        this.$notify(i18n.t('record5', [25, '维保内容不能超过25个图片']))
        return false
      } else if (this.remarksVerify.imgLength > 25) {
        this.$notify(i18n.t('record6', [25, '备注不能超过25个图片']))
        return false
      } else {
        if (this.isEdit) {
          update(data).then(res => {
            this.Close();
            this.$bus.$emit('getL')
            // this.$bus.$emit('getv')
          }, error => {
            !_.isEmpty(error) && this.$notify(error)
          })
        } else {
          insert(data).then(res => {
            this.Close();
             this.$bus.$emit('getL')
            // this.$bus.$emit('getv')
          }, error => {
            !_.isEmpty(error) && this.$notify(error)
          })
        }
      }
    },
    //选择电站
    openStation () {
      this.stationFlag = true
      this.$nextTick(() => {
        this.$refs.SelectStationCommon.show([], "single")
      })
    },
    EmitStationIdList (data) {
      this.targetList = []
      this.targetList.push(data);
      this.stationFlag = false
      this.form.systemTypeId = data.id
      this.form.systemTypeName = data.name
      this.form.objectType = 1//打开设备
      this.$nextTick(() => {
        this.$refs.AlarmStation.show()
      })
    },
    removeTarget () {
      this.targetList = []
      this.form.systemTypeId = null
      this.form.systemTypeName = null
      this.$refs.AlarmStation.reset(true)
    },
  },
  mounted () {
    lib.fillHeight();
    this.$nextTick(() => {
      lib.setScroll($(this.$el).find('[fillHeight][scroll]'));
    });
  }
}
</script>
<style scoped="scoped" lang="scss">
.jia {
  padding-top: 0.1em;
  padding-left: 0.5em;
  border-radius: 0.2em;
  .tagBox {
    display: inline-block;
  }
}
.station-wrap {
  position: relative;
  z-index: 10002;
}
</style>
<style >
.time .datepicker-popup {
  z-index: 10002;
}
</style>



// WEBPACK FOOTER //
// src/view/application/maintenance/part/NewMaintenance.vue